module.exports = __webpack_public_path__ + "static/media/lost-and-wanted.36e878d9.jpg";